import React from 'react'
import { Card, Divider } from 'react-md'

import CancelEditDialog from './CancelEditDialog'
import DeleteDialog from './DeleteDialog'
import ViewHeader from '../ViewHeader'
import ViewContent from '../ViewContent'

const View = ({
  artwork,
  disableDelete,
  enablePublish,
  enableUnpublish,
  isCancelEditDialogVisible,
  isDeleteDialogVisible,
  onSave,
  onGoBack,
  onRequestPublishing,
  onCancelPublishRequest,
  onPublish,
  onUnpublish,
  onShowDeleteDialog,
  onHideDeleteDialog,
  onDelete,
  onToggleDetails,
  onHideCancelEditDialog,
  form,
  isUploading,
  isEditing,
  uploadStatus,
  uploadProgress
}) => (
  <div>
    <CancelEditDialog
      visible={isCancelEditDialogVisible}
      onCancel={onHideCancelEditDialog}
      onConfirm={onToggleDetails}
    />
    <DeleteDialog
      visible={isDeleteDialogVisible}
      onCancel={onHideDeleteDialog}
      onConfirm={onDelete}
    />
    <Card>

      <ViewHeader
        artworkStatus={artwork.status}
        disableDelete={disableDelete}
        enablePublish={enablePublish}
        enableUnpublish={enableUnpublish}
        onSubmit={onSave}
        onGoBack={onGoBack}
        onDelete={onShowDeleteDialog}
        onRequestPublishing={onRequestPublishing}
        onCancelPublishRequest={onCancelPublishRequest}
        onPublish={onPublish}
        onUnpublish={onUnpublish}
        onToggleDetails={onToggleDetails}
        form={form}
        uploadStatus={uploadStatus}
        isUploading={isUploading}
        isEditing={isEditing}
      />

      <Divider />

      <ViewContent
        artwork={artwork}
        form={form}
        uploadStatus={uploadStatus}
        uploadProgress={uploadProgress}
        isUploading={isUploading}
        isEditing={isEditing}
      />

    </Card>
  </div>
)

export default View



// WEBPACK FOOTER //
// ./src/containers/ArtworkView/View/index.js